export const isAllDigits = (code?: string) => {
  return code ? [...code].every((char) => char >= "0" && char <= "9") : false;
};
